/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import PropTypes from 'prop-types'
import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { DueOut } from '../../../assets/ts/data/dueout/dueout'
import { Inquiry } from '../../../assets/ts/data/inquiry/inquiry'
import { defaultToEmptyString } from '../../../assets/ts/formatting/formatting'
import { formatPhoneNumber } from '../../../assets/ts/general/general'
import Accordions from '../../../components/accordions/accordions'
import Buttons from '../../../components/buttons/buttons'
import { PreviousPageContext } from '../../../store/previous-page-provider'
import { UserContext } from '../../../store/user-context-provider'
import CustomerDetails from './customer-details'
import './details.css'
import InquiryDueoutDetails from './inquiry-dueout-details'

interface DetailProps {
  currentInquiry: DueOut | Inquiry
  customerDetails: any
  description: string
  hideButton:boolean
  inquiryDueoutDetails: any
  previousPage : string
  roleContext: any
  title: string
}
const Details = ({
  currentInquiry,
  customerDetails,
  description,
  hideButton,
  inquiryDueoutDetails,
  previousPage,
  roleContext,
  title
}: DetailProps) => {
  const [show, setShow] = useState(false)
  const { me } = useContext(UserContext)
  const navigate = useNavigate()

  const handleOpen = () => {
    setShow(!show) // Toggle accordion
  }
  function navigateToFormPage() {
    title === 'Due Out Details' ? navigate(`/createdueout/${(currentInquiry as DueOut).DueOutGUID}`, { state: { prevPage: previousPage } }) :
      navigate(`/createinquiry/${(currentInquiry as Inquiry).InquiryGUID}` , { state: { prevPage: previousPage } })
  }

  const accordionItems = [
    {
      Id: 1,
      content: <CustomerDetails detailsitems={customerDetails?.map(item => {
        if (item.title === "Duty Phone") {
          return {
            link:"#",
            subtitle: formatPhoneNumber(item.subtitle),
            title:'Duty Phone'
          }
        } else {
          return item
        }
      })} />,
      is_active: 'true',
      title: 'Customer Details',
    },
    {
      Id: 2,
      content: (
        <InquiryDueoutDetails
          description={description}
          inquiryDueoutDetails={inquiryDueoutDetails}
        />
      ),
      is_active: 'false',
      title: title,
    },
  ]

  return (
    <>
      <div className='card-header border-bottom1 d-flex align-items-center'>
        <div className='d-flex flex-wrap align-items-center'>
          <h2
            aria-label={title}
            className='title-color20 poppins-semibold font-14 mx-1'
            tabIndex={0}
          >
            {defaultToEmptyString(title)}
          </h2>
          {currentInquiry?.Priority && (
            <div
              aria-describedby='Priority'
              className='title-color20 poppins-semibold font-11 mx-1 border-left1 px-2'
              id='Priority'
              tabIndex={0}
            >
              Priority : <span className='color-primary'>{currentInquiry?.Priority }</span>
            </div>
          )}
        </div>
        {(currentInquiry?.StatusCode === 'SUBMITTED' || currentInquiry?.StatusCode === 'NOT_STARTED' || currentInquiry?.StatusCode === 'REOPENED') &&
        (
          (currentInquiry?.ServicingBy === 'MPF' && !roleContext.isCSS && !roleContext.isCustomer) || 
          (currentInquiry?.ServicingBy === 'CSS' && (roleContext.isCSS || roleContext.isCPOwner|| roleContext.isMPFOwner)) ||
          (currentInquiry?.Customer?.userID === me?.userId && currentInquiry?.InquiryID)
        ) &&
        <Buttons
          aria-label='Edit'
          className='text-nowrap btn-border btn btn-sm font-0 font-lg-14 color-primary btn-border-radius3 p-relative ms-auto sourcesansprosemibold'
          icon='icon-pencil me-1 font-12 me-xl-1'
          label='Edit'
          onClick={navigateToFormPage}
        />}
      </div>
      <div className='card-body'>
        <div className='formaccordions'>
          <Accordions
            accordionitemclass='border-radius'
            className='accordions accordion-bordered overflow-hidden'
            expandedIndex={[1,2]}
            icon='icon-arrow-down font-13 ms-auto bold bgcolor-23 border-radius4 p-1'
            inputProps={{
              className: 'w-100 p-2',
              contentclassName: 'border-top3 py-0',
            }}
            items={accordionItems}
          />
        </div>
      </div>
    </>
  )
}

export default Details
